import NavigationBar from 'carbon-react/lib/components/navigation-bar';
import React from 'react';

import { UILoader } from '@futrli/ui-components';

export const OnboardingLoader = () => (
  <>
    <NavigationBar variant="black" position="sticky" orientation="top" />
    <UILoader isFull={true} />
  </>
);
